<template>
  <custom-dialog class="protocol-import-topic-dialog" width="1388px" :title="model.title" :visible="visible" v-on="$listeners" :fullscreen="true" :append-to-body="true">
    <div class="dialog-body" :style="{ height: clientHeight + 'px' }">
      <div class="ub">
        <div class="ub-f1">
          <h1 class="title">{{ $t('dms_protocol_import_topic_dialog.Topiclie_biao') }}</h1>
          <div class="box">
            <div class="search-hd">
              <el-select style="float: left; width: 200px" v-model="formSearch.fromProtocolCode" :clearable="false" @change="onPageChange({ page: 1 })">
                <el-option v-for="(item, index) in deviceType" :key="index" :label="item.protocolCode" :value="item.protocolCode"></el-option>
              </el-select>
              <el-input style="float: right; width: 200px" v-model="formSearch.search" clearable :placeholder="$t('dms_protocol_import_topic_dialog.TopicmcTopicbm')" @input="onPageChange({ page: 1 })"></el-input>
            </div>
            <div style="width: 608px; flex: 1">
              <custom-table
                v-model="deviceIn"
                :data="deviceList"
                height="100%"
                :column="tableColumn"
                type="checkbox"
                @filter="filterChange"
                @sort="sortChange"
                :slots="['topicName', 'topicCode']"
                ref="tb1"
                selectableKey="disabled"
              >
                <template v-slot:topicName="scope">
                  <el-button size="mini" type="text" @click="onDetail(scope.row.topicId)">{{ scope.row.topicName }}</el-button>
                </template>
                <template v-slot:topicCode="scope">
                  <span class="topic-code" @click="checkRelativeModelDetail(scope.row)">{{ scope.row.topicCode }}</span>
                </template>
              </custom-table>
            </div>
            <div class="table-page">
              <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
            </div>
          </div>
        </div>
        <div class="ubv ub-ac ub-xc" style="padding: 0 16px">
          <div class="btn" @click="addDevice">
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="btn2" @click="removeDevice">
            <i class="el-icon-arrow-left"></i>
          </div>
        </div>
        <div class="ub-f1 selected-device">
          <h1 class="title">{{ $t('dms_protocol_import_topic_dialog.yi_xuanTopic') }}</h1>
          <div class="box">
            <div class="search-hd">
              <el-input clearable :placeholder="$t('dms_protocol_import_topic_dialog.Topicming_cheng')" style="width: 608px" v-model="formSearch.selectedKeyword"></el-input>
            </div>
            <div style="width: 608px; flex: 1">
              <custom-table v-model="deviceOut" :data="selectedData" :column="tableColumn" height="100%" ref="tb2" type="checkbox" @filter="filterChange" @sort="sortChange" :slots="['topicName']">
                <template v-slot:topicName="scope">
                  <el-button size="mini" type="text" @click="onDetail(scope.row.topicId)">{{ scope.row.topicName }}</el-button>
                </template>
              </custom-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <!-- topic详情预览 drawer -->
    <topic-detail-drawer v-if="showTopicDetailDialog" :visible.sync="showTopicDetailDialog" :id="curTopicId"></topic-detail-drawer>
    <!-- 查看关联物模型 -->
    <check-relative-model-dialog
      v-if="showCheckRelativeModelDialog"
      @close="showCheckRelativeModelDialog = false"
      :model="dialogModel4"
      :protocolCode="dialogModel4.data.protocolCode"
    ></check-relative-model-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import topicDetailDrawer from './topic_detail_drawer.vue';
import checkRelativeModelDialog from './check_relative_model_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: {
    topicDetailDrawer,
    checkRelativeModelDialog,
  },
  props: {
    protocolCode: String,
  },
  data() {
    return {
      visible: true,
      formSearch: {
        topicClass: '',
        search: '',
        pageSize: 50,
        pageNum: 1,
        fromProtocolCode: '',
        protocolCode: '',
        keyword: '',
        selectedKeyword: '',
      },
      deviceList: [],
      totalRows: 0,
      selectRow: [],
      tableCode: 'protocol_import_topic',
      curRow: {},
      showRelationDialog: false,
      dialogModel1: {},

      showTopicDetailDialog: false,
      curTopicId: '',
      deviceIn: [],
      deviceOut: [],
      clientHeight: document.body.clientHeight - 100,
      selectedDevice: [],
      deviceType: [],
      showCheckRelativeModelDialog: false,
      dialogModel4: {
        data: {},
      },
    };
  },
  computed: {
    selectedData() {
      const ret = this.fuzzyQuery(this.selectedDevice, ['topicName'], this.formSearch.selectedKeyword);

      // 分组排序
      ret.sort((a, b) => {
        const res = a.topicClass - b.topicClass;
        return res;
      });
      return ret;
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize, false);
    this.getTableColumn();
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize, false);
  },
  methods: {
    checkRelativeModelDetail(row) {
      this.dialogModel4 = {
        data: row,
        title: this.$t('dms_protocol_import_topic_dialog.ckglwmx'),
      };
      this.showCheckRelativeModelDialog = true;
    },
    formatDeviceList() {
      const list = this.deviceList;
      const selectedData = this.selectedDevice;
      list.forEach((item) => {
        if (selectedData.some(obj => obj.topicId === item.topicId)) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    async init() {
      await this.getDeviceType();
      this.getTableList();
    },
    async getDeviceType() {
      const res = await this.$getJSON(apis.ComponentCopyListProtocol, {
        // protocolCode: this.protocolCode
      });
      this.deviceType = res.data.filter(item => item.protocolCode !== this.protocolCode);
      this.formSearch.fromProtocolCode = this.deviceType[0].protocolCode;
    },
    addDevice() {
      this.deviceIn.forEach((item) => {
        const has = this.selectedDevice.find(t => t.topicId === item.topicId);
        if (!has) {
          this.selectedDevice.push(item);
        }
      });
      this.$refs.tb1.$refs.tb1.clearSelection();
      this.formatDeviceList();
    },
    removeDevice() {
      this.deviceOut.forEach((item) => {
        this.selectedDevice = this.selectedDevice.filter(t => t.topicId !== item.topicId);
      });
      // 直接formatDeviceList，table不更新禁用状态
      const copyList = [...this.deviceList];
      this.deviceList = [];
      setTimeout(() => {
        this.deviceList = copyList;
        this.formatDeviceList();
      }, 0);
    },
    onResize() {
      this.clientHeight = document.body.clientHeight - 100;
    },
    onDetail(id) {
      this.curTopicId = id;
      this.showTopicDetailDialog = true;
    },

    getTableList() {
      this.$getJSON(apis.TopicImportPage, {
        ...this.formSearch,
        protocolCode: this.protocolCode,
      }).then((res) => {
        this.deviceList = res.data.list.filter(item => item.state);
        this.totalRows = res.data.total;
        this.formatDeviceList();
      });
    },
    confirm() {
      const reqData = this.getReqData();
      this.$postJSON(apis.TopicImport, reqData).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    getReqData() {
      return {
        protocolCode: this.protocolCode,
        topicIdList: this.selectedDevice.map(item => item.topicId),
      };
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
.protocol-import-topic-dialog {
  .topic-code {
    text-decoration: underline;
    cursor: pointer;
  }
  .selector {
    padding-top: 0;
    .el-form-item {
      margin-bottom: 0 !important;
    }
  }

  .el-dialog.is-fullscreen {
    width: 1388px;
  }

  .el-input-group__prepend {
    font-size: 0;
    border-radius: 2px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .dialog-body {
    overflow: hidden;
    display: flex;
    // height: 700px;

    .ub {
      flex: 1;
    }
  }
  .box {
    margin-top: 16px;
    padding: 0 16px 5px 16px;
    border: 1px solid #dee2e6;
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    // height: calc(100% - 40px);
  }

  .ub-f1 {
    width: 380px;
    display: flex;
    flex-direction: column;
  }
  .title {
    color: #35405b;
    font-weight: bold;
    font-size: 14px;
  }
  .btn {
    cursor: pointer;
    width: 24px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    background-color: #00afff;
    border: 1px solid rgba(24, 144, 255, 1);
    text-align: center;
    color: #ffffff;
  }
  .btn2 {
    cursor: pointer;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    text-align: center;
    color: #000000;
    margin-top: 10px;
  }

  .el-dialog__footer {
    padding-top: 10px;
    padding-bottom: 10px;
    border-top: 1px solid #e9ebec;
  }

  .selected-device {
    // padding-top: 80px;
  }
}
</style>
